export default function queryElement(selector, parent) {
  const lookUp = parent && parent instanceof Element ? parent : document;
  return selector instanceof Element ? selector : lookUp.querySelector(selector);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/misc/queryElement.js
// module id = 6
// module chunks = 0